import React from "react";
import "./UploadPage.style.scss";

import FileSelect from "./../../components/FileSelect/FileSelect.component";

const UploadPage = () => {
  return <FileSelect />;
};
export default UploadPage;
